import { Icon } from '@sleepstation/components'
import { LinkBase } from '@sleepstation/components-base'
import { HLayout } from '@sleepstation/components-layouts'
import { LAYOUT_ALIGN, LAYOUT_JUSTIFY } from '@sleepstation/const'
import { mq } from '@sleepstation/style-api-helpers'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(LinkBase)`
  color: white;
  text-decoration: none;
  font-size: 18px;

  ${mq(`xSmallOnly`)} {
    font-size: 16px;
  }
`

const Label = styled.span`
  padding: 4px;
`

const Inner = styled(HLayout).attrs({
  justify: LAYOUT_JUSTIFY.LEFT,
  align: LAYOUT_ALIGN.CENTER,
})`
  padding: 16px 28px;
  border-bottom: 1px solid rgba(255 255 255 / 50%);
  cursor: pointer;
  transition: color 0.25s ease-in-out;

  &:hover {
    color: #f7b85f;
  }
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const VerticalMenuItem = ({ linkUrl, iconKey, linkText, setMenuIsOpen }) => (
  <Layout
    href={linkUrl}
    onClick={() => setMenuIsOpen(false)}
    forceOpenInSameWindow
  >
    <Inner>
      <Icon name={iconKey} />
      <Label>{linkText}</Label>
    </Inner>
  </Layout>
)

VerticalMenuItem.propTypes = {
  linkUrl: PropTypes.string.isRequired,
  iconKey: PropTypes.string.isRequired,
  linkText: PropTypes.string.isRequired,
  setMenuIsOpen: PropTypes.func.isRequired,
}

VerticalMenuItem.defaultProps = {}

export default VerticalMenuItem
